import type { ClientPersonChangeHomeAreaRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useParticipantsPersonEventsApi } from '@/features/api/hooks/participant/useParticipantsPersonEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const usePersonChangeHomeArea = () => {
  const queryClient = useQueryClient();
  const api = useParticipantsPersonEventsApi();

  return useApiMutation({
    mutationFn: (
      clientPersonChangeHomeAreaRequest: ClientPersonChangeHomeAreaRequest
    ) =>
      api.onPersonPersonChangeHomeAreaRequest({
        clientPersonChangeHomeAreaRequest
      }),
    onSuccess: () => {
      /*
      Todo: invalidation here causes some unsent requests during registration. As we do not use the onboarding endpoint during the app, this might be fine
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.ONBOARDING_STATUS]
      });
      */
      queryClient.invalidateQueries({ queryKey: [API_CACHE_KEYS.PERSON] });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.SELECTED_GEO_AREAS]
      });
      queryClient.invalidateQueries({ queryKey: [API_CACHE_KEYS.FEATURES] });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.POST_CREATION_OPTIONS]
      });
    }
  });
};
